import { Input, Box } from '@drone-js/core';
import React from 'react';
import styled from 'styled-components';

export type OtpInputProps = {
    id: number;
    value: string;
    onChange: (value: string, boxId: number) => void;
    onBackSpace: (boxId: number) => void;
    inputRef: React.RefObject<HTMLInputElement>;
    error?: boolean;
};

const OtpInputComponent = styled(Input)({
    boxSizing: 'initial',
});

export const OtpInput: React.FC<OtpInputProps> = props => {
    const [isTouched, setIsTouched] = React.useState(false);
    const digitRegex = /^\d+$/;

    const { id, inputRef, onBackSpace, onChange, error, value } = props;

    const handleInput = e => {
        const input = e.target.value.replace(/\s/g, '');
        const value = digitRegex.test(input) ? input : '';
        setIsTouched(!!value);
        props.onChange(value, id);
    };

    const handleKeyDown = e => {
        const value = e.target.value;
        if (!value && e.key === 'Backspace') {
            onBackSpace(id);
        }
    };

    React.useEffect(() => {
        if (value) setIsTouched(true);
    }, [value]);

    React.useEffect(() => {
        if (inputRef.current) inputRef.current.pattern = '[0-9]+';
    }, [inputRef]);

    return (
        <div style={{ display: 'flex', height: '50px', width: '48px' }}>
            <OtpInputComponent
                ref={inputRef}
                data-cy={`otp-box-${id}`}
                name={`otp-${id}`}
                key={id}
                value={value}
                intent={error ? 'error' : isTouched ? 'success' : undefined}
                onChange={handleInput}
                onKeyDown={handleKeyDown}
                selectOnFocus
                type="tel"
                label=""
                clearLabel=""
                enableTrailingControls={false}
                autoComplete="off"
                autoFocus={id === 0}
            />
        </div>
    );
};
